export const defData = {
  categories: [
    'V=ieaou',
    'L=īēāōū',
    'C=ptcqbdgmnlrhs',
    'F=ie',
    'B=ou',
    'S=ptc',
    'Z=bdg'
  ],
  rewriteRules: ['lh=lj'],
  soundChanges: [
    '[sm]//_#',
    'i/j/_V',
    'L/V/_',
    'e//Vr_#',
    'v//V_V',
    'u/o/_#',
    'gn/nh/_',
    'S/Z/V_V',
    'c/i/F_t',
    'c/u/B_t',
    'p//V_t',
    'ii/i/_',
    'e//C_rV'
  ],
  lexicon: [
    'lector',
    'doctor',
    'focus',
    'jocus',
    'districtus',
    'cīvitatem',
    'adoptare',
    'opera',
    'secundus',
    'fīliam',
    'pōntem'
  ],
  outputFormat: 'oo',
  showDiff: true,
  showChanges: true,
  ruleReport: true,
  rewriteOutput: true,
  results: undefined
}
